// extracted by mini-css-extract-plugin
module.exports = {"base":"CheckBox_base__26LAf","disabled":"CheckBox_disabled__1FXsn"};